module.exports = __webpack_public_path__ + "static/media/quote-close.b54e2681.png";